import { OnInit, Component } from "@angular/core";
import { Globals } from "../globals";
import { SelectableLab } from "../carrier/selectable-lab";
import { Router } from "@angular/router";
import { MasterDataService } from "../masterdata/masterdata.service";
import { ErrorHandler } from "../utils/error-handler";
import { MessagesService } from "../messages/messages.service";
import { LabEmitterService } from "../common-services/lab-emitter.service"
import { AuthUtil } from '../common-services/auth-util';
import jwt_decode from 'jwt-decode';

// Lab component to handle lab on inital page load
// @author Naveen
@Component({
	selector: 'app-lab',
	templateUrl: './lab.component.html',
	styleUrls: ['./lab.component.css']
})
export class LabComponent implements OnInit {

	blocked = false;
	selectedLab: SelectableLab;
	errorHandler: ErrorHandler = new ErrorHandler;
	labs: SelectableLab[];
	isLabSelected = false;
	loggedUserName: string;
	yetToSelectLab = true;
	hasArrayAndNGSSwitchOn = false;
	hasUISelection = false;
	newUI = true;
	constructor(private readonly _globals: Globals, private readonly router: Router, private readonly _masterDataService: MasterDataService,
		private readonly _messageService: MessagesService, private readonly _labEmitterService: LabEmitterService) { }

	//loads the all lab
	ngOnInit() {
		this.blocked = true;
		this.yetToSelectLab = true;
		this.hasArrayAndNGSSwitchOn = false;
		this.hasUISelection = false;
		let selectedLab = JSON.parse(localStorage.getItem('lab'))
		if (selectedLab) {
			this.isLabSelected = true;
		}

		setTimeout(() => {
			this.getLabs()
		}, 2000)
	}

	getLabs() {
		this._masterDataService.getLabsWithOptionalHistory(true, false).subscribe({
			next: (results) => {
				this.blocked = false;
				if (!results) {
					return;
				}
				console.log("labs:", results.data);
				this.labs = [];
				results.data.forEach(lab => {
					this.labs.push({ label: lab.name, lab: lab })
				});

			},
			error: (error: any) => {
				this.blocked = false;
				let message = this.errorHandler.handleError(error);
				this._messageService.addErrorMessage(message);
			}
		});
	}

	// Assigns selected lab and loads application
	assignLabAndLoad(event) {
		console.log("Lab selected: " + this.selectedLab.label)

		if(this.selectedLab.lab.uiSelection){
			this.yetToSelectLab = false;
			this.hasUISelection = true;
			return;
		}
		
		localStorage.setItem("newUI", String(true));
		if (this.selectedLab.lab.ngs && this.selectedLab.lab.array) {
			this.hasArrayAndNGSSwitchOn = true;
			this.yetToSelectLab = false;
			return;
		}
		if (this.selectedLab.lab.ngs) {
			localStorage.setItem('process', 'NGS');
		} else {
			localStorage.setItem('process', 'ARRAY')
		}
		this.emitLabChangeAndNavigate();
	}

	selectUI(newUI: boolean){
		this.newUI = newUI;
		localStorage.setItem("newUI", String(newUI));
		if (this.selectedLab.lab.ngs && this.selectedLab.lab.array) {
			this.hasUISelection = false;
			this.hasArrayAndNGSSwitchOn = true;
			return;
		}

		if (this.selectedLab.lab.ngs) {
			localStorage.setItem('process', 'NGS');
		} else {
			localStorage.setItem('process', 'ARRAY')
		}
		this.emitLabChangeAndNavigate();
	}

	openProcess(process: string) {
		console.log("Choosen process ", process)
		if (process === 'NGS') {
			localStorage.setItem('process', 'NGS')
		} else {
			localStorage.setItem('process', 'ARRAY')
		}
		this.emitLabChangeAndNavigate();
	}

	emitLabChangeAndNavigate() {
		localStorage.setItem('lab', JSON.stringify(this.selectedLab));
		this._globals.selectedLab = this.selectedLab;
		this._labEmitterService.emitLab(this.selectedLab)
		if (this.newUI) {
			this.router.navigate(['/delivery']);
		} else {
			this.router.navigate(['/apg-delivery-box-manager']);
		}
	}

	azureLogOut() {
		const util = new AuthUtil()
		util.logout()
	}

	get azureLoginStatus() {
		let authUtil = new AuthUtil()
		let accessToken = authUtil.getAccessToken()
		if (accessToken) {
			let access_token = jwt_decode(accessToken);
			this.loggedUserName = access_token.name;
		}
		return accessToken ? true : false
	}

}